(function() {
    'use strict';

    angular
        .module('app')
        .directive('popup', popup);

    popup.$inject = ['$window', 'loginService'];
    
    function popup($window, loginService) {
        // Usage:
        //     <popup></popup>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                shown: "=",
                onOk: "=?",
                onCancel: "=?",
                okDisabled: "=",
                cancelDisabled: "="
            },
            replace: true,
            transclude: true,
            templateUrl: 'app/common/templates/popup.html'
        };
        return directive;

        function link(scope, element, attrs) {

            scope.okLabel = loginService.resourceStrings["OK"]; // "OK"
            scope.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"

            //make modal
            var overlay = element[0].getElementsByClassName('ng-modal-overlay');

            angular.element(overlay).bind('click', function (e) {
                e.preventDefault();
            })

            scope.dialogStyle = {};
            if (attrs.width)
                scope.dialogStyle.width = attrs.width;
            if (attrs.height)
                scope.dialogStyle.height = attrs.height;
            scope.okClicked = function () {
                var getType = {};
                if (getType.toString.call(scope.onOk) === '[object Function]') {
                    scope.onOk();
                }
                
            }
            scope.cancelClicked = function () {
                var getType = {};
                if (getType.toString.call(scope.onCancel) === '[object Function]') {
                    scope.onCancel();
                }
            }
        }
    }

})();